var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"flex items-center justify-center w-full py-2.5 px-4 text-white font-bold text-lg bg-darkblue",attrs:{"href":"/basket"}},[_c('icon-basket',{staticClass:"mr-2"}),_vm._v("\n    Go to cart\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }